/*eslint-disable */
import React, { useEffect, FC } from 'react';
import injectSheet from 'react-jss';
import { TweenMax, Back } from 'gsap';
import Loader from '../../components/loader';
import { HeaderImageParams } from '../../constants/headerImageParams';
import { options } from '../../components/loader/options';
import Analytics from '@analytics/index';

interface Props {
  successTitle?: String;
  successSubtitle?: String;
  successDescription?: String;
  classes: any;
}

const styleSheet = (theme: any) => ({
  formWrapper: theme.formWrapper,
  confettiWrapper: {
    opacity: 0,
    position: 'relative',
    width: '100%',
    maxWidth: '700px',
    height: 'auto',
    zIndex: 1,
    margin: '0 auto',
  },
  animationContainer: {
    // Overrides loader defaults
    '& div#loader': {
      maxWidth: '600px',
      margin: '0 auto',
      height: 'auto',
    },
  },
  copy: {
    outline: 0,
    color: '#223762',
    textAlign: 'center',
    fontFamily: 'CircularStd, sans-serif',
  },
  title: {
    outline: 0,
    fontSize: '36px',
    fontWeight: '500',
    margin: 0,
    opacity: 0,
  },
  description: {
    outline: 0,
    fontSize: '24px',
    opacity: 0,
  },
  message: {
    outline: 0,
    marginTop: '100px',
    fontSize: '14px',
    color: '#6373a4',
    opacity: 0,
  },
});

const successPage: FC<Props> = ({
  successTitle,
  successSubtitle,
  successDescription,
  classes,
}: Props) => {
  let copyRef: any = null;

  useEffect(() => {
    //animate copy in
    for (var i = 0; i < copyRef.children.length; i++) {
      // Will focus the screen reader to speak the success message //
      // copyRef.focus();

      let copy = copyRef.children[i];
      TweenMax.from(copy, 0.5, {
        y: '+=30',
        ease: Back.easeOut,
        delay: 0.25 + i / 5,
      });
      TweenMax.to(copy, 0.5, {
        opacity: 1,
        delay: 0.25 + i / 5,
      });
    }
  }, []);

  useEffect(() => {
    Analytics.EventAnalytics.track('success_viewed', {});
  }, []);

  return (
    <div className={classes.formWrapper}>
      <div className={classes.animationContainer} id="animation-container">
        <Loader
          isVisible={true}
          animationData={options.SUCCESS}
          speed={HeaderImageParams.SUCCESS.speed}
          loop={HeaderImageParams.SUCCESS.loop}
        />
      </div>
      <div />
      <div
        tabIndex={0}
        aria-live="polite"
        aria-label={`${successTitle}. ${successSubtitle}. ${successDescription}`}
        ref={item => (copyRef = item)}
        className={classes.copy}
        onLoad={() => {
          copyRef.current.focus;
        }}
      >
        <p aria-hidden={'true'} className={classes.title}>
          {successTitle}
        </p>
        <p aria-hidden={'true'} className={classes.description}>
          {successSubtitle}
        </p>
        <p aria-hidden={'true'} className={classes.message}>
          {successDescription}
        </p>
      </div>
    </div>
  );
};

successPage.defaultProps = {
  successTitle: 'Alright!',
  successSubtitle: 'Get ready',
  successDescription: 'Personalizing for you…',
};

export default injectSheet(styleSheet)(successPage);
